export default __webpack_public_path__ + "static/media/sliderImage-3.c50fbd2d.jpg";